export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            还在等什么？
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            加入5000万吃瓜群众的行列，第一时间获取最新爆料
          </p>
          <Link
            to="/category/daily-contest"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-800 text-background-50 font-semibold rounded-full text-sm hover:bg-foreground-950 transition-colors whitespace-nowrap"
          >
            立即加入吃瓜大队 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="w-full h-32 md:h-40 rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20abstract%20composition%20of%20floating%20social%20media%20icons%20and%20news%20elements%2C%20warm%20gradient%20background%20from%20dark%20to%20light%2C%20modern%20digital%20media%20concept%2C%20clean%20minimalist%20banner%20design%2C%20professional%20tech%20aesthetic%2C%20soft%20warm%20tones%20with%20subtle%20accents%2C%20editorial%20quality&width=1600&height=320&seq=cta-banner-2026&orientation=landscape"
            alt="加入51黑料网吃瓜大队"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}